(function () {
  var hamburger = {
    body:  document.querySelector('body'),
    navToggle: document.querySelector('.js-side-nav-toggle'),
    nav: document.querySelector('.js-side-nav'),
    mobileHeader: document.querySelector('.header__mobile'),
    // navLinks: document.querySelector('.js-side-nav a'),

    doToggle: function () {
      this.navToggle.classList.toggle('expanded');
      this.nav.classList.toggle('expanded');
      this.body.classList.toggle('scroll-hidden');
      this.mobileHeader.classList.toggle('header__mobile--menu-open');
    },
  };

  hamburger.navToggle.addEventListener('click', function (e) {
    hamburger.doToggle(e);
  });
  // hamburger.navLinks.addEventListener('click', function(e) { hamburger.doToggle(e); });
})();
